import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PageFrame, ServerIP, DiscordButton } from '../../components';
import { fetchWebsiteStats, fetchNewsArticles } from '../../services/api';
import './Home.css';

function Home() {
  const [latestNews, setLatestNews] = useState([]);
  const [stats, setStats] = useState({
    onlinePlayers: 0,
    uniquePlayersRegistered: 0,
  });
  const [targetStats, setTargetStats] = useState({
    onlinePlayers: 0,
    uniquePlayersRegistered: 0,
  });

  useEffect(() => {
    // Fetch stats on component mount
    const loadStats = async () => {
      const { data, error } = await fetchWebsiteStats();
      if (data && !error) {
        setTargetStats({
          onlinePlayers: data.onlinePlayers,
          uniquePlayersRegistered: data.uniquePlayersRegistered,
        });
      }
    };

    // Fetch news on component mount
    const loadNews = async () => {
      const { data, error } = await fetchNewsArticles();
      if (data && !error) {
        setLatestNews(data.slice(0, 3));
      }
    };

    loadStats();
    loadNews();
  }, []);

  // Animate numbers counting up
  useEffect(() => {
    if (targetStats.onlinePlayers === 0 && targetStats.uniquePlayersRegistered === 0) return;

    const duration = 500; // 0.5 seconds
    const steps = 30;
    const stepDuration = duration / steps;

    let currentStep = 0;
    const interval = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;
      const easeOutProgress = 1 - Math.pow(1 - progress, 3); // Ease-out cubic

      setStats({
        onlinePlayers: Math.round(targetStats.onlinePlayers * easeOutProgress),
        uniquePlayersRegistered: Math.round(targetStats.uniquePlayersRegistered * easeOutProgress),
      });

      if (currentStep >= steps) {
        clearInterval(interval);
        setStats(targetStats); // Ensure exact final values
      }
    }, stepDuration);

    return () => clearInterval(interval);
  }, [targetStats]);

  return (
    <PageFrame>
      <header className="header">
        <div className="sword-divider">
          <span className="sword-line"></span>
          <span className="sword-icon">⚔</span>
          <span className="sword-line"></span>
        </div>
        <h1 className="logo-text">VOXALE</h1>
        <p className="subtitle">Minecraft Server</p>
      </header>

      <ServerIP />

      <div className="stats-bar">
        <div className="stat">
          <span className="stat-number">
            {stats.onlinePlayers}
          </span>
          <span className="stat-label">Online Now</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat">
          <span className="stat-number">
            {stats.uniquePlayersRegistered.toLocaleString()}
          </span>
          <span className="stat-label">Unique Players</span>
        </div>
      </div>

      <div className="features">
        <div className="feature">
          <div className="feature-icon">🎮</div>
          <div className="feature-content">
            <h3 className="feature-title">Minigames</h3>
            <p className="feature-desc">Bedwars, Skywars, and more!</p>
          </div>
        </div>
        <div className="feature">
          <div className="feature-icon">🎉</div>
          <div className="feature-content">
            <h3 className="feature-title">Events</h3>
            <p className="feature-desc">Weekly tournaments & prizes</p>
          </div>
        </div>
        <div className="feature">
          <div className="feature-icon">👑</div>
          <div className="feature-content">
            <h3 className="feature-title">Ranks</h3>
            <p className="feature-desc">Unlock perks as you play</p>
          </div>
        </div>
        <div className="feature">
          <div className="feature-icon">✨</div>
          <div className="feature-content">
            <h3 className="feature-title">Custom</h3>
            <p className="feature-desc">Everything handcrafted</p>
          </div>
        </div>
        <div className="feature">
          <div className="feature-icon">💬</div>
          <div className="feature-content">
            <h3 className="feature-title">Social</h3>
            <p className="feature-desc">Active Discord community</p>
          </div>
        </div>
        <div className="feature">
          <div className="feature-icon">👥</div>
          <div className="feature-content">
            <h3 className="feature-title">Friends</h3>
            <p className="feature-desc">Party up and play together</p>
          </div>
        </div>
      </div>

      <DiscordButton />

      <section className="news-section">
        <h2 className="section-title">
          <span className="title-line"></span>
          Latest News
          <span className="title-line"></span>
        </h2>

        {latestNews.length === 0 ? (
          <div className="news-empty">No news yet. Check back soon!</div>
        ) : (
          latestNews.map(article => (
            <Link to={`/news/${article.slug || article.id}`} className="news-item-link" key={article.id || article.slug}>
              <div className="news-item">
                <span className="news-date">{article.date}</span>
                <h3 className="news-title">{article.title}</h3>
                <p className="news-excerpt">{article.excerpt}</p>
              </div>
            </Link>
          ))
        )}

        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
          <Link to="/news" className="btn btn-gold">View All News</Link>
        </div>
      </section>
    </PageFrame>
  );
}

export default Home;
